import { render, staticRenderFns } from "./BoxSpecialofferLink.vue?vue&type=template&id=6447b278&scoped=true&"
import script from "./BoxSpecialofferLink.vue?vue&type=script&lang=ts&"
export * from "./BoxSpecialofferLink.vue?vue&type=script&lang=ts&"
import style0 from "./BoxSpecialofferLink.vue?vue&type=style&index=0&id=6447b278&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6447b278",
  null
  
)

export default component.exports